import { render, staticRenderFns } from "./FavouriteTreatments.vue?vue&type=template&id=07e1c2f4"
import script from "./FavouriteTreatments.vue?vue&type=script&lang=js"
export * from "./FavouriteTreatments.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports